import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from '../contexts/Language';

export const Card = props => {
  const { className, Title, Description, Tools, children, Logo } = props;
  return (
    <div className="row">
      <div className="col-12">
        <div className={`card ${className}`}>
          <div className="card-body">
            {Title && <h4 className="mt-0 header-title">{Translate(Title)}</h4>}
            {Description && <p className="text-muted m-b-30">{Translate(Description)}</p>}
            <div className="card-tool">
              {Tools}
            </div>
            {children}
            {Logo && <img src={`/assets/psp-logo/${(Logo || 'defaultlogo.svg')}`} alt="" height="30" className="card-logo" />}
          </div>
        </div>
      </div>
    </div>
  );
};

Card.propTypes = {
  className: PropTypes.string,
  Title: PropTypes.string,
  Description: PropTypes.string,
  Tools: PropTypes.node,
  children: PropTypes.node.isRequired,
  Logo: PropTypes.func,
};

Card.defaultProps = {
  className: '',
  Title: null,
  Description: null,
  Logo: null,
  Tools: '',
};
